import { Modal, Result, Button } from 'antd';
import UnpublishedIcon from '@mui/icons-material/Unpublished';

const ConfirmUnpublishCatalogModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    catalogName,
    primaryShades
}) => {
    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            centered
            footer={null}
        >
            <Result
                icon={<UnpublishedIcon style={{ color: primaryShades.primary300, fontSize: 64 }} />}
                title="Unpublish Catalog"
                subTitle={`Are you sure you want to unpublish the catalog "${catalogName || 'Untitled'}"? This will make it temporarily unavailable to users.`}
                extra={[
                    <Button 
                        key="unpublish" 
                        type="primary" 
                        onClick={onConfirm}
                    >
                        Unpublish
                    </Button>,
                    <Button 
                        key="cancel" 
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default ConfirmUnpublishCatalogModal;
